
import TalqsTemplate from "@tal/talqs-template";
let scriptinteraction;
let linkinteraction;
let scripttemplate;
let linktemplate;

// 初始化mathjax
export function initMathjax() {

  initqsInteraction();
  return;

}


// MathJax 解析

const renderMathJax = (el = null) =>
  new Promise(resolve => {
    const hub = window.MathJax.Hub
    hub.Queue(['Typeset', hub, el], resolve)
  })

/**
 *
 * @param el<HTMLElement|any> 渲染的元素对象
 * @param id<string | any> 渲染的元素id或者对象,默认为''
 */
export const MathJaxParse = (
  el = null,
  id = '',
  callback = null
) => {
  const mathJax = window.MathJax
  if (mathJax) {
    let renderCallback = null
    if (mathJax.typesetPromise) {
      // MathJax >=3.0
      renderCallback = mathJax.typesetPromise
    } else if (mathJax.Hub) {
      // 兼容旧版MathJax <3.0
      renderCallback = renderMathJax
    }
    if (typeof renderCallback === 'function') {
      renderCallback().then(() => {
        if (typeof callback === 'function') {
          callback()
        }
        TalqsTemplate.autoLayout()
      })
    }
  } else {
    throw new Error('没有在window上找到MathJax属性')
  }
}


export function initqsInteraction() {

  if (!window.MathJax) {
    window.MathJax = {
      startup: {
        typeset: false,
        ready() {
          if (MathJax.version === '3.0.5') {
            const SVGWrapper = MathJax._.output.svg.Wrapper.SVGWrapper
            const CommonWrapper = SVGWrapper.prototype.__proto__
            SVGWrapper.prototype.unicodeChars = function (text, variant) {
              if (!variant) variant = this.variant || 'normal'
              return CommonWrapper.unicodeChars.call(this, text, variant)
            }
          }
          MathJax.startup.defaultReady()
        }
      },
      options: {
        ignoreHtmlClass: 'ignore_math',
        processHtmlClass: 'tex2jax_process'
      },
      tex: {
        inlineMath: [
          ['$', '$'],
          ['\\', '\\']
        ],
        packages: ['base', 'ams', 'noerrors', 'noundefined', 'boldsymbol']
      },
      svg: {
        fontCache: 'global'
      }
    };


    let script = document.createElement("script");
    script.src = "https://static-apps.oss-cn-beijing.aliyuncs.com/library/MathJax3.0/3.0.5/tex-svg-full.js";
    script.defer = true
    document.head.appendChild(script);

  }



}

export let scriptStatus = false
export function initTalqsInteractionJs() {
  if (!scriptinteraction) {
    window.TalqsInteraction = null;
    window.judge = null;
    console.log("document.createElement('script');", window.TalqsInteraction, window)
    scriptinteraction = document.createElement('script');
    scriptinteraction.src = 'https://static.speiyou.com/_cdn_/talqs-interaction-phone/1.0.23-alpha/index.min.js';
    document.head.appendChild(scriptinteraction);
    scriptinteraction.onload = () => {
      scriptStatus = true
    }

    setQsInteraction(JSON.parse(localStorage.getItem("userDetail")));
  }
}

export function removeqsInteraction() {
  if (scriptinteraction) {
    TalqsInteraction = null;
    judge = null;
    document.head.removeChild(scriptinteraction);
    scriptinteraction = null;
    scriptStatus = false
  }

}
/**
 * 设置试题交互相关信息
 */
let count = 0;
export const setQsInteraction = (userDetail) => {
  // console.log("userdetail", userDetail)
  const {
    TalqsInteraction
  } = window;
  if (TalqsInteraction) {
    console.log("TalqsInteraction ok", userDetail)
    // 设置用户信息后试题交互行为才生效
    let result = TalqsInteraction.setUserConfig(userDetail);
  } else {
    setTimeout(() => {
      setQsInteraction(userDetail);
    }, 500)
  }
}




// WEBPACK FOOTER //
// ./src/js/talqs.js